import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'

const HeadingAdapter = ({
  children, level, color, className,
}) => (
  <Typography variant={level} style={{ color }} className={className}>
    { children }
  </Typography>
)

HeadingAdapter.defaultProps = {
  children: null,
  className: '',
  color: '#FFFFFF',
  level: 'h1',
}

HeadingAdapter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
}

export default HeadingAdapter
